<template>
    <div class="corps">
        <canvas ref="canvasConstellation" id="overlay"></canvas>

        <div id="container-component">
            <!-- Colonne des paramètres -->
            <div id="container-parametre">
                <div class="parametre-scroll-container">
                    <div class="parametre-grid">
                        <span @click="changeSelectedPara(getIdByTitle(para.title))"
                              class="parametre-item"
                              v-for="para in lesPara"
                              :key="getIdByTitle(para.title)"
                              :id="getIdByTitle(para.title)"
                              :class="{'selected-parametre-item': selectedPara === getIdByTitle(para.title)}">
                            {{ para.label || para.title }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Colonne du contenu -->
            <div id="container-card">
                <component :is="'Parametre' + selectedPara"></component>
            </div>
        </div>
    </div>
</template>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
    }

    .corps {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        min-height: 100vh;
        width: 100%;
        color: rgba(17, 147, 147);
        z-index: 1;
    }

    #overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        background-color: white;
    }

    #container-component {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: 95%;
        max-width: 1700px;
        border-radius: 20px;
        padding: 30px;
        gap: 30px;
        z-index: 1;
    }

    /* Colonne des onglets : largeur compacte fixe pour que l'espace gagne (grand ecran)
       aille a la carte de contenu plutot qu'a la liste d'onglets. */
    #container-parametre {
        flex: 0 0 280px;
        max-width: 280px;
        padding: 0px 25px;
        border-radius: 15px;
    }

    .parametre-grid {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .parametre-item {
        padding: 15px 25px;
        border-radius: 12px;
        text-align: center;
        cursor: pointer;
        font-weight: 700;
        transition: all 0.3s ease-in-out;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(17, 147, 147);
        box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
    }

        .parametre-item:hover, .selected-parametre-item {
            background: rgba(17, 147, 147);
            color: rgba(255, 255, 255);
            transform: scale(1.1);
            box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
        }

    #container-card {
        flex: 2;
        /* min-width:0 : sans ca, ce flex item prend sa taille de contenu (min-width:auto) et
           s'etend pour une table large -> l'ecran deborde et les colonnes de droite deviennent
           inatteignables. A 0, il reste borne et le panneau interne (.grille-conteneur) scrolle. */
        min-width: 0;
        padding: 30px;
        background: rgba(0, 0, 0, 0.04);
        backdrop-filter: blur(20px);
        border-radius: 15px;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.25);
    }


    @media (max-width: 768px) {
        #overlay {
            display: none;
        }


        .parametre-scroll-container {
            display: flex;
            align-items: center;
            overflow-x: auto;
            overflow-y: hidden;
            gap: 15px;
            position: relative;
            -ms-overflow-style: none; 
            scrollbar-width: thin; 
        }

  
            .parametre-scroll-container::-webkit-scrollbar {
                height: 8px; 
            }

            .parametre-scroll-container::-webkit-scrollbar-thumb {
                background-color: rgba(17, 147, 147, 0.6); 
                border-radius: 10px; 
                transition: background-color 0.3s ease;
            }

                .parametre-scroll-container::-webkit-scrollbar-thumb:hover {
                    background-color: rgba(17, 147, 147, 0.9);
                }

            .parametre-scroll-container::-webkit-scrollbar-track {
                background: rgba(255, 255, 255, 0.3); 
                border-radius: 10px;
            }

            .parametre-scroll-container::-webkit-scrollbar-button {
                display: none; 
            }

        .parametre-scroll-container {
            scrollbar-color: rgba(17, 147, 147, 0.6) rgba(255, 255, 255, 0.3);
            scrollbar-width: thin; 
        }

        .parametre-item {
            display: flex;
            padding: 5px 10px;
            min-width: 100px;
            justify-content: center;
            align-items: center;
            text-align: center;
            box-shadow: none;
        }

            .parametre-item:hover, .selected-parametre-item {
                box-shadow: none;
                transform: none;
            }

        .parametre-grid {
            flex-direction: row;
            gap: 10px; 
        }

        #container-component {
            flex-direction: column;
            gap: 20px; 
        }

        #container-card {
            margin: auto;
        }

        #container-parametre {
            /* Annule le flex:0 0 280px du desktop : en colonne (mobile) il fixerait la hauteur. */
            flex: 1 1 auto;
            max-width: 100%;
            margin: auto;
        }
    }

</style>

<script>
    import { defineComponent } from 'vue';
    import ParametreGeneral from './ParametreGeneral.vue';
    import ParametreOptionPraticien from './ParametreOptionPraticien.vue';
    import ParametreFacture from './ParametreFacture.vue';
    import ParametrePracticien from './ParametrePraticien.vue';
    import ParametreDroitsADRI from './ParametreDroitsADRI.vue';
    import ParametreGestionActes from './ParametreGestionActes.vue';
    import ParametreTables from './ParametreTables.vue';
    import RequestManager from "../../../script/request";
    export default defineComponent({
        components: {
            //Les composants
            ParametreGeneral,
            ParametreOptionPraticien,
            ParametreFacture,
            ParametrePracticien,
            ParametreDroitsADRI,
            ParametreGestionActes,
            ParametreTables
        },
        data: function () {
            return {
                message: 'Hello world',
                appliqueTarifOutreMer: false,
                selectedPara: "General",
                lesPara: [
                    { title: "Général", id: "General" },
                    { title: "Option Praticien", id: this.remplacerEspaceParTrait("Option Praticien") },
                    { title: "Gestion Actes", id: this.remplacerEspaceParTrait("Gestion Actes") },
                    { title: "Facture", id: "Facture" },
                    { title: "Praticien", id: "Praticien" },
                    { title: "Droits ADRI", id: this.remplacerEspaceParTrait("Droits ADRI") },
                    // id "Tables" -> composant dynamique ParametreTables (panneau de parametrage
                    // des tables integre) ; label affiche distinct du title (mono-mot pour l'id).
                    { title: "Tables", label: "Paramétrage tables", id: "Tables" }
                ],
            }
        },

        computed: {

        },

        methods: {
            changeSelectedPara(para) {
                this.selectedPara = para;
            },
            getIdByTitle(title) {
                const id = this.removeAccents(this.supprimerEspaces(title));
                return id;
            },
            supprimerEspaces(chaine) {
                return chaine.replace(/\s/g, '');
            },
            remplacerEspaceParTrait(chaine) {
                return chaine.replace(/\s/g, '-');
            },
            removeAccents(str) {
                return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            },
            initConstellationEffect() {
                const canvas = this.$refs.canvasConstellation;
                if (!canvas) return;

                class Constellation {
                    constructor(canvas, options) {
                        this.canvas = canvas;
                        this.ctx = canvas.getContext("2d");
                        this.config = Object.assign({
                            star: { color: "rgba(169, 169, 169, 0.5)", width: 1, randomWidth: true },
                            line: { color: "rgba(17, 147, 147, 0.5)", width: 0.5 },
                            position: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
                            velocity: 0.1,
                            length: 100,
                            distance: 120,
                            radius: 250,
                            stars: []
                        }, options);

                        this.resizeCanvas();
                        window.addEventListener("resize", () => this.resizeCanvas());
                        this.init();
                    }

                    resizeCanvas() {
                        this.canvas.width = window.innerWidth;
                        this.canvas.height = window.innerHeight;
                        this.config.position.x = this.canvas.width / 2;
                        this.config.position.y = this.canvas.height / 2;
                        this.createStars();
                    }

                    createStars() {
                        this.config.stars = [];
                        for (let i = 0; i < this.config.length; i++) {
                            this.config.stars.push(this.createStar());
                        }
                    }

                    createStar() {
                        return {
                            x: Math.random() * this.canvas.width,
                            y: Math.random() * this.canvas.height,
                            vx: this.config.velocity - Math.random() * 0.5,
                            vy: this.config.velocity - Math.random() * 0.5,
                            radius: this.config.star.randomWidth ? Math.random() * this.config.star.width : this.config.star.width
                        };
                    }

                    animateStars() {
                        for (let star of this.config.stars) {
                            if (star.x < 0 || star.x > this.canvas.width) star.vx = -star.vx;
                            if (star.y < 0 || star.y > this.canvas.height) star.vy = -star.vy;
                            star.x += star.vx;
                            star.y += star.vy;
                        }
                    }

                    drawStars() {
                        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        this.ctx.fillStyle = this.config.star.color;
                        for (let star of this.config.stars) {
                            this.ctx.beginPath();
                            this.ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
                            this.ctx.fill();
                        }
                    }

                    drawLines() {
                        this.ctx.strokeStyle = this.config.line.color;
                        this.ctx.lineWidth = this.config.line.width;

                        for (let i = 0; i < this.config.stars.length; i++) {
                            for (let j = i + 1; j < this.config.stars.length; j++) {
                                let a = this.config.stars[i], b = this.config.stars[j];
                                let distance = Math.hypot(a.x - b.x, a.y - b.y);

                                if (distance < this.config.distance) {
                                    this.ctx.beginPath();
                                    this.ctx.moveTo(a.x, a.y);
                                    this.ctx.lineTo(b.x, b.y);
                                    this.ctx.stroke();
                                }
                            }
                        }
                    }

                    loop() {
                        this.animateStars();
                        this.drawStars();
                        this.drawLines();
                        requestAnimationFrame(() => this.loop());
                    }

                    init() {
                        this.canvas.addEventListener("mousemove", (e) => {
                            this.config.position.x = e.clientX;
                            this.config.position.y = e.clientY;
                        });

                        this.loop();
                    }
                }

                new Constellation(canvas, { length: 120, radius: 500 });
            }
        },
        props: ["parametreComposant"],
        mounted() {
            if (this.parametreComposant == undefined) {
                this.$router.push({ name: "ParametreWithComponent", params: { parametreComposant: "General" } });
                this.selectedPara = "General"
                this.$nextTick(() => {
                    this.initConstellationEffect();
                });
            }
            else {
                this.selectedPara = this.parametreComposant
                this.$nextTick(() => {
                    this.initConstellationEffect();
                });
            }
        }
        ,
        created() {
        },
        watch: {
            async selectedPara(newValue, oldValue) {
                //console.log(`newValue=${newValue} et oldValue=${oldValue}`);
                console.log(newValue);
                if (newValue == undefined) {
                    document.getElementById(newValue).classList.add("selected-parametre-item");
                }
                else {
                    this.$router.push({ name: "ParametreWithComponent", params: { parametreComposant: newValue } });
                    document.getElementById(oldValue).classList.remove("selected-parametre-item");
                    document.getElementById(newValue).classList.add("selected-parametre-item");
                }
                console.log(document.getElementById(newValue));

                if (newValue === "OptionPraticien") {
                    RequestManager.EnvoyerMessageWebView({ action: "SignerParam", parameters: [] });

                    window.addEventListener("message", this.handleMessage);
                } else {
                    RequestManager.EnvoyerMessageWebView({ action: "FermerSignaturePad", parameters: [] });
                    window.removeEventListener("message", this.handleMessage);
                }
            }
        }

    });
</script>
